import { Locality, Province } from '@/interfaces/localities';
import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function getProvinces() {
  return request({
    url: 'provinces/',
    method: 'GET',
  }) as AxiosPromise<Province[]>;
}

export async function getLocalities(province: number) {
  return request({
    url: `provinces/${province}/localities/`,
    method: 'GET'
  }) as AxiosPromise<Locality[]>;
}

export async function getAllLocalities() {
  return request({
    url: 'localities/',
    method: 'GET',
  }) as AxiosPromise<Locality[]>;
}
